import React, { useEffect, useState } from "react";
import "../assets/css/bootstrap.min.css";
import "../assets/css/style.css";
import { Link } from "react-router-dom";
import axios from "axios";
import card1 from "../assets/images/Collection/artwork-1.png";
import card2 from "../assets/images/Collection/artwork-2.png";
import card3 from "../assets/images/Collection/artwork-3.png";
import artistPic from "../assets/images/Collection/artist-picture.png";
import Header from "./Header";
import { useParams } from "react-router-dom";
import { getCollectionItems, buy } from "../blockchain/functions/functions";

const Collection = () => {
  let { id } = useParams();
  const [items, setItems] = useState([]);
  const [amountToBuy, setAmountToBuy] = useState(0);
  const [address, setAddress] = useState("");
  const [collectionData, setCollectionData] = useState({
    name: "",
    description: "",
    image: "",
    items: [],
  });

  const getItems = async () => {
    if (address) {
      let collectionItems = await getCollectionItems(address);

      console.log(collectionItems);
      setItems(collectionItems);
    }
  };

  const getCollectionDetails = async () => {
    console.log(id);
    if (id) {
      let details = await axios.get(
        `https://nfttest.xyz/nftapi/index.php/home/get_collections/${id}`
      );

      console.log(details.data);
      setAddress(details.data.contract_address);
      setCollectionData(details.data);
    }
  };

  useEffect(() => {
    getCollectionDetails();
    // getItems();
  }, []);
  return (
    <div className="main-wrapper">
      {/* Header area start */}
      <Header />
      {/* Header area end */}
      <div className="container-fluid">
        <Link to="/Collection">
          <div
            className="row  justify-content-center"
            style={{
              background: `url(${collectionData.image})`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              backgroundSize: "cover",
            }}
          >
            <div className="header-text col-lg-7 col-sm-12"></div>
            <div className="col-lg-4 col-sm-10 artist text-center">
              <span>{collectionData.name}</span>
            </div>
          </div>
        </Link>
      </div>
      {/* Hero slider end */}

      {/* Collection content area start */}
      <div className="container margin-70 text-center collection-content">
        <div className="row justify-content-center">
          <div className="col-lg-2"></div>
          <div className="col-lg-8">
            {!address && <h3>Collection still not available</h3>}
            <p>{collectionData.description}</p>
          </div>
          <div className="col-lg-2"></div>

          {collectionData.items.length !== 0 &&
            collectionData.items.map((item, index) => {
              return (
                <div key={index} className="card text-left">
                  <img
                    src={`https://nfttest.xyz/nftapi/${item.images}`}
                    className="card-img-top"
                    alt=""
                  />

                  <div className="card-body">
                    <h3>{item.item_title} </h3>
                    <strong>Price: {item.price} ETH</strong>
                    <br />
                    <strong>
                      {item.sell_method == "bid" ? "Auction" : "Fixed Price"}
                    </strong>
                    <h6 className="card-text">
                      <strong>{item.edition} Editions</strong>
                      {address && (
                        <Link to={`/SpecificItem/${id}/${address}/${index}`}>
                          <button
                            // onClick={() => handleBuy(index, item.price)}
                            style={{ width: "120px" }}
                            className="buy-button"
                          >
                            Buy
                          </button>
                        </Link>
                      )}
                    </h6>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
      {/* Collection content area end */}

      {/* why we love  art vader area start */}
      <div className="container text-center mb-5 collection-content">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <h3>Why We Love Art Vader</h3>
            <Link to="/UserProfileArtist">
              <img
                src={artistPic}
                alt="artistPic"
                className="collection-artist-pic"
              />
            </Link>
            <p>
              Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam
              nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam
              erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci
              tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo
              consequat.
            </p>
            <h3>Follow Art Vader to receive exclusive release info</h3>
            <button>Follow</button>
            <h3>Learn More about Duke Dumont</h3>
            <h6>
              <Link to="#">https://website.com</Link>
            </h6>
            <h6>
              <Link to="#">https://socialmedia.com</Link>
            </h6>
          </div>
        </div>
      </div>
      {/* why we love  art vader area end */}
    </div>
  );
};

export default Collection;
